function buscarPreguntaporCodigoV2(Codigo, Preguntas){

    var indice = 0;

    for (let Pregunta of Preguntas)
    {

        if (Pregunta["code"] == Codigo)
        {

            let resultado = {

                status : "OK",
                question: indice,
                data: Pregunta
            }

            return resultado;

        }

        var indice = (indice+1);

    }

    let resultado = {

        status : "KO"
    }

    return resultado;

}

exports.buscarPreguntaporCodigoV2 = buscarPreguntaporCodigoV2;